module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Space Grey Aluminum + Black Open.4b71b19d.png";